import React from 'react';

import {FormItemSkeleton, SkeletonItem} from 'src/components/skeleton';

export const EzProxySkeleton = () => (
    <FormItemSkeleton labelWidth={54}>
        <SkeletonItem width={300} height={32}/>
    </FormItemSkeleton>
);
